export type CashClosureStatus =
  | 'balanced'
  | 'overage'
  | 'shortage'
  | 'minor'
  | 'major';

export interface CashDenomination {
  label: string;
  value: number;
  qty: number;
}

export const TND_DENOMS = [
  { label: '50 TND', value: 50 },
  { label: '20 TND', value: 20 },
  { label: '10 TND', value: 10 },
  { label: '5 TND', value: 5 },
  { label: '2 TND', value: 2 },
  { label: '1 TND', value: 1 },
  { label: '500 millimes', value: 0.5 },
  { label: '200 millimes', value: 0.2 },
  { label: '100 millimes', value: 0.1 },
  { label: '50 millimes', value: 0.05 },
];

export const MIN_FLOAT = 250;
export const CLOSURE_CREATED_EVENT = 'incashflow:closure-created';

const BALANCED_TOLERANCE = 0.01;
const MINOR_THRESHOLD = 50;
const MAJOR_THRESHOLD = 100;

export function computeClosureStatus(difference: number): CashClosureStatus {
  const abs = Math.abs(difference);
  if (abs < BALANCED_TOLERANCE) return 'balanced';
  if (abs >= MAJOR_THRESHOLD) return 'major';
  if (abs <= MINOR_THRESHOLD) return 'minor';
  return difference > 0 ? 'overage' : 'shortage';
}

export function formatPeriodDuration(start: string, end: string): string {
  const ms = new Date(end).getTime() - new Date(start).getTime();
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  if (h > 24) {
    const d = Math.floor(h / 24);
    return `${d}j ${h % 24}h`;
  }
  return h > 0 ? `${h}h ${m}min` : `${m}min`;
}

export function formatRelativeClosureDate(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diff = (today.getTime() - target.getTime()) / 86_400_000;
  const time = d.toLocaleTimeString('fr-TN', { hour: '2-digit', minute: '2-digit' });
  if (diff === 0) return `Aujourd'hui · ${time}`;
  if (diff === 1) return `Hier · ${time}`;
  return `${d.toLocaleDateString('fr-TN')} · ${time}`;
}
